module.exports = __webpack_public_path__ + "img/circle-thin-white.af5891bc.svg";